exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".l4xHCcR2IzFnxg6egfw3i{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;height:20px}.l4xHCcR2IzFnxg6egfw3i .qSjm6nVoL9ESCJgItIvfc{font-size:8px}html[dir=ltr] .l4xHCcR2IzFnxg6egfw3i .qSjm6nVoL9ESCJgItIvfc{margin-right:10px}html[dir=rtl] .l4xHCcR2IzFnxg6egfw3i .qSjm6nVoL9ESCJgItIvfc{margin-left:10px}.l4xHCcR2IzFnxg6egfw3i ._1VGQqD9KMg6W0irkI4q2W1{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:210px}", ""]);

// exports
exports.locals = {
	"optionWrapper": "l4xHCcR2IzFnxg6egfw3i",
	"coloredBullet": "qSjm6nVoL9ESCJgItIvfc",
	"optionLabel": "_1VGQqD9KMg6W0irkI4q2W1"
};